module.exports = __webpack_public_path__ + "static/BC-Falster-Grotesk-Regular-dda88fb0551fe9cb03d871705a4b366f.woff2";